import { render, staticRenderFns } from "./Showcases.vue?vue&type=template&id=28b95084&"
import script from "./Showcases.vue?vue&type=script&lang=js&"
export * from "./Showcases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports